import { useContext } from "react";

import { IPRestrictionContext } from "../../contexts/user/IPRestrictionContext";

const useIPRestriction = () => {
  const context = useContext(IPRestrictionContext);

  if (!context) throw new Error("IPRestrictionContext must be used inside IPRestrictionProvider");

  return context;
};

export default useIPRestriction;
